import { render, staticRenderFns } from "./select.md?vue&type=template&id=8f48cde0"
import script from "./select.md?vue&type=script&lang=js"
export * from "./select.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports